import { createAsyncReducer } from '../../../standard-actions/reducers';

import { IOrderTrackerState } from '../../state';
import { initialState } from '../../state/initial-state';
import { formatOrderProducts} from '../../methods/load-orders-payload';
import cloneDeep from 'lodash-es/cloneDeep';
import { ILoadOrdersV2SuccessAction,
    ILoadOrdersV2StartAction,
    LoadOrdersV2ErrorAction,
    ISortOrderIntV2Action,
    IApplySelectColumnsActionIntV2,
    IOrderIntV2ReferenceAction } from '../../actions/order-tracker-int-uplift/load-order-int-new';
import { filterOrdersIntV2 } from '../../methods/order-tracker-int-uplifted/search-orders-new';

export type LoadOrdersAction
    = ILoadOrdersV2StartAction
    | ILoadOrdersV2SuccessAction
    | LoadOrdersV2ErrorAction;

export type SortOrderAction = ISortOrderIntV2Action;

export type ApplySelectColumnsAction = IApplySelectColumnsActionIntV2;

const init = (state: IOrderTrackerState, action: LoadOrdersAction) => ({
    ...state,
    activeIntOrdersV2: {
        ...state.activeIntOrdersV2,
        data: {
            orders: [],
            original_orders: [],
            isPartialResponse: null,
        },
        status: action.status
    }
});

const success = (state: IOrderTrackerState, action: LoadOrdersAction) => {
    const originalOrders = (action as ILoadOrdersV2SuccessAction).data.original_orders;
    return ({
        ...state,
        activeIntOrdersV2: {
            ...state.activeIntOrdersV2,
            status: action.status,
            data: {
                ...state.activeIntOrdersV2.data,
                original_orders: originalOrders,
                orders: formatOrderProducts(originalOrders),
                isPartialResponse: (action as ILoadOrdersV2SuccessAction).data.isPartialResponse,
            }
        }
    })
};

const failure = (state: IOrderTrackerState, action: LoadOrdersAction) => ({
    ...state,
    activeIntOrdersV2: {
        ...initialState.activeIntOrdersV2,
        status: action.status,
        error: (action as LoadOrdersV2ErrorAction).error
    }
});

export const sortOrdersReducer = (state: IOrderTrackerState, action: ISortOrderIntV2Action) => {
   return ({
        ...state,
        activeIntOrdersV2: {
            ...state.activeIntOrdersV2
        }
    })
}

export const applySelectColumnsReducer = (state: IOrderTrackerState) => {
    return ({
        ...state,
        activeIntOrdersV2: {
            ...state.activeIntOrdersV2,
        }
    });
}

export const loadPagination = (state) => {
    return ({
        ...state,
        activeIntOrdersV2: {
            ...state.activeIntOrdersV2,
        }
    })
};
export const updateOrderListFilterV2 = (state: IOrderTrackerState, action: IOrderIntV2ReferenceAction) => {
    const filters = state.orderSearchV2.orders.filters;
    const searchString = state.orderSearchV2.orders.searchString;

    let filterdActiveOrders = cloneDeep(state.activeIntOrdersV2.data.original_orders);
    filterdActiveOrders = filterOrdersIntV2(filterdActiveOrders, filters, searchString);
    const finalData = {
        ...state,
        activeIntOrdersV2: {
            ...state.activeIntOrdersV2,
            data: {
                ...state.activeIntOrdersV2.data,
                orders: filterdActiveOrders,
            }
        }
    };
    return finalData
}
export const loadOrdersIntV2Reducer = createAsyncReducer(initialState, init, success, failure);
